<script>
    import { isMobile, isNotSupportObserver } from "@/utils";

    export default {
        name: "HomeWork",
        data() {
            return {
                animationStep: 0,
                animationDelay: 2500,
            };
        },
        mounted() {
            if (!isMobile(992)) {
                this.animationObserver();
            }
        },
        computed: {
            firstStep() {
                return this.animationStep === 1 || this.animationStep === 2;
            },
            secondStep() {
                return this.animationStep === 2;
            },
        },
        methods: {
            animationObserver() {
                if (isNotSupportObserver()) {
                    this.animationStep = 2;
                }

                const options = {
                    root: null,
                    rootMargin: "0px",
                    threshold: 0.8,
                };

                const observer = new IntersectionObserver((entries, observer) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const step = Number(entry.target.getAttribute("data-step")) || 1;

                            this.$refs.animationLine.addEventListener("animationend", () => {
                                this.animationDelay = 0;
                            });

                            if (step < 2) {
                                this.animationStep = step;
                            } else {
                                setTimeout(() => {
                                    this.animationStep = step;
                                }, this.animationDelay);
                            }
                            observer.unobserve(entry.target);
                        }
                    });
                }, options);

                document.querySelectorAll(".js-home-work-observable").forEach((element) => {
                    observer.observe(element);
                });
            },
        },
    };
</script>

<template>
    <section class="home-work" id="how-work">
        <span class="home-work__line">
            <svg width="526" height="426" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    ref="animationLine"
                    class="animation-line"
                    :class="{
                        'is-animated-1': firstStep,
                        'is-animated-2': secondStep,
                    }"
                    d="M475.5 27C318 105.5 159.3 18.3 55 124.5a144.4 144.4 0 0 0-36.7 89c0 41.2 16.8 65 46.7 92 116.3 104.7 288-21 445 102"
                    stroke="#BCE7E5"
                    stroke-width="2"
                    stroke-linecap="round"
                />

                <g
                    class="animation-circle animation-circle--1"
                    :class="{ 'is-animated': firstStep }"
                >
                    <circle
                        cx="490.5"
                        cy="18.5"
                        r="17.5"
                        fill="#fff"
                        stroke="#BCE7E5"
                        stroke-width="2"
                        stroke-linecap="round"
                    />
                    <path
                        d="M491.6 24c.2 0 .3-.1.3-.3V12.6c0-.2-.1-.3-.3-.3h-2.2a.6.6 0 0 0-.4.1l-3 2.5c-.2.2-.2.3 0 .5l.6.7c.1.2.3.2.5 0l2.8-2.3v9.9c0 .2.1.3.3.3h1.4Z"
                        fill="#BCE7E5"
                    />
                </g>
                <g
                    class="animation-circle animation-circle--2"
                    :class="{ 'is-animated': firstStep }"
                >
                    <circle
                        cx="18.5"
                        cy="215.5"
                        r="17.5"
                        fill="#fff"
                        stroke="#BCE7E5"
                        stroke-width="2"
                        stroke-linecap="round"
                    />
                    <path
                        d="M17 219.3v-.1l2-2c1.6-1.8 2.8-3.3 2.8-5 0-1.6-1.2-3.2-3.6-3.2a4 4 0 0 0-4 3c-.1.3 0 .4.2.4h1.2c.1 0 .3 0 .3-.2a2.2 2.2 0 0 1 2.2-1.5c1.2 0 2 .7 2 1.6 0 1.1-1 2.3-2.4 3.8l-3.1 3.2c-.2.2-.2.3-.2.5v.9c0 .2.1.3.3.3h7.1c.2 0 .3-.1.3-.3v-1.1c0-.2 0-.3-.3-.3h-4.7Z"
                        fill="#BCE7E5"
                    />
                </g>
                <g
                    class="animation-circle animation-circle--3"
                    :class="{ 'is-animated': secondStep }"
                >
                    <circle
                        cx="507.5"
                        cy="407.5"
                        r="17.5"
                        fill="#fff"
                        stroke="#BCE7E5"
                        stroke-width="2"
                        stroke-linecap="round"
                    />
                    <path
                        d="M509 406.8a2.6 2.6 0 0 0 1.7-2.6c0-1.6-1.2-3.2-3.6-3.2a4 4 0 0 0-4.1 3c0 .3 0 .4.3.4h1.1c.2 0 .3 0 .3-.2.4-1 1.2-1.5 2.3-1.5 1.2 0 2 .7 2 1.7s-.7 1.7-2.8 1.7h-.4c-.2 0-.3 0-.3.3v.9c0 .2 0 .3.3.3h.4c2.3 0 3 .7 3 2 0 1.2-.8 2-2.3 2-1 0-2-.6-2.2-1.5-.1-.2-.2-.3-.4-.3H503c-.2 0-.3.1-.3.3.3 1.5 1.7 3.1 4.4 3.1s4-1.7 4-3.6c0-1.3-.6-2.3-2-2.8Z"
                        fill="#BCE7E5"
                    />
                </g>
            </svg>
        </span>
        <h2 class="home-work__title page-title">Как работает умный сад</h2>
        <div class="home-work__row">
            <div class="home-work__text width-435">
                <h3 class="home-work__caption">Без почвы</h3>
                В&nbsp;основе умных садов iGarden лежит метод гидропоники&nbsp;&mdash;
                выращивание растений без почвы. Побеги удерживает инертный пористый субстрат,
                который способствует дыханию корней. В&nbsp;iGarden такой средой служит минерал
                вермикулит. С&nbsp;ним легко обращаться, а&nbsp;гранулы не&nbsp;оставляют
                грязных следов.
            </div>
            <div class="home-work__text width-315">
                <div class="home-work__caption mobile-hidden">&nbsp;</div>
                В&nbsp;субстрате нет питательных веществ. Все полезные элементы корневая
                система получает из&nbsp;воды. Поэтому для здорового роста рекомендуется
                добавлять в&nbsp;воду специальные удобрения.
            </div>
            <div class="home-work__image-wrapper">
                <picture>
                    <source
                        media="(max-width: 992px)"
                        srcset="/static/igarden/home/work-1--mobile.svg"
                    />
                    <img class="desktop-hidden" src="" alt="" />
                </picture>
                <div class="home-work__image">
                    <picture>
                        <source
                            media="(min-width: 991px)"
                            srcset="/static/igarden/home/work-1.svg"
                        />
                        <img class="mobile-hidden" src="" alt="" />
                    </picture>
                    <svg
                        class="animation-water"
                        :class="{ 'is-animated': firstStep }"
                        width="300"
                        height="270"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="143" cy="219" r="1" fill="#fff" />
                        <circle
                            cx="137.41"
                            cy="200.75"
                            r="1.66"
                            fill="#fff"
                            stroke="#fff"
                            stroke-width="2.08"
                        />
                        <circle
                            cx="118.46"
                            cy="225.11"
                            r="1.04"
                            fill="#fff"
                            stroke="#fff"
                            stroke-width="1.53"
                        />
                        <circle cx="102" cy="207" r="1" fill="#fff" />
                        <circle cx="84" cy="226" r="1" fill="#fff" />
                        <circle
                            cx="161.76"
                            cy="210.67"
                            r="1.04"
                            fill="#fff"
                            stroke="#fff"
                            stroke-width="1.53"
                        />
                        <circle cx="169" cy="229" r="1" fill="#fff" />
                        <circle cx="189" cy="204" r="1" fill="#fff" />
                        <circle
                            cx="198.5"
                            cy="224.5"
                            r="1.04"
                            fill="#fff"
                            stroke="#fff"
                            stroke-width=".92"
                        />
                        <circle
                            cx="222.5"
                            cy="215.5"
                            r="1.04"
                            fill="#fff"
                            stroke="#fff"
                            stroke-width=".92"
                        />
                        <circle
                            cx="211.5"
                            cy="197.5"
                            r="1.04"
                            fill="#fff"
                            stroke="#fff"
                            stroke-width=".92"
                        />
                    </svg>
                </div>
            </div>
        </div>
        <div data-step="1" class="home-work__row js-home-work-observable">
            <div class="home-work__text">
                <h2 class="home-work__caption">Круглый год</h2>
                Для жизни растениям требуется свет. Осенью и&nbsp;зимой солнце светит недолго,
                из-за чего цветы не&nbsp;цветут, а&nbsp;листья не&nbsp;развиваются.
                В&nbsp;iGarden с&nbsp;этой проблемой помогает справится система автоматического
                освещения. Она заменяет солнце и&nbsp;продляет световой день.
            </div>
            <div class="home-work__image-wrapper width-435">
                <picture>
                    <source
                        media="(max-width: 992px)"
                        srcset="/static/igarden/home/work-2--mobile.svg"
                    />
                    <img class="desktop-hidden" src="" alt="" />
                </picture>
                <div class="home-work__image">
                    <picture>
                        <source
                            media="(min-width: 991px)"
                            srcset="/static/igarden/home/work-2.svg"
                        />

                        <img class="mobile-hidden" src="" alt="" />
                    </picture>
                    <svg
                        class="animation-light"
                        :class="{ 'is-animated': firstStep }"
                        width="300"
                        height="270"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="m41.5 166 16-134.5c86.5 4 117 3 171 1.5L241 166c-71 15-126.5 15-199.5 0Z"
                            fill="#FDFF9F"
                            fill-opacity=".5"
                        />
                    </svg>
                </div>
            </div>
        </div>
        <div data-step="2" class="home-work__row js-home-work-observable">
            <div class="home-work__text width-435">
                <h2 class="home-work__caption">Чисто, быстро, без хлопот</h2>
                При помощи гидропоники можно выращивать декоративные растения, а&nbsp;также
                овощи, ягоды, пряные и&nbsp;лекарственные травы. В&nbsp;водном питательном
                растворе не&nbsp;заводятся паразиты и&nbsp;сорняки, его легко менять
                и&nbsp;подобрать оптимальный состав.
            </div>
            <div class="home-work__text width-315">
                <div class="home-work__caption mobile-hidden">&nbsp;</div>
                Метод сочетает все плюсы растениеводства и&nbsp;убирает недостатки. Быстро,
                эффективно, чисто и&nbsp;красиво.
            </div>
            <div class="home-work__image-wrapper">
                <picture>
                    <source
                        media="(max-width: 992px)"
                        srcset="/static/igarden/home/work-3--mobile.svg"
                    />
                    <img class="desktop-hidden" src="" alt="" />
                </picture>
                <div class="home-work__image">
                    <picture>
                        <source
                            media="(min-width: 991px)"
                            srcset="/static/igarden/home/work-3.svg"
                        />
                        <img class="mobile-hidden" src="" alt="" />
                    </picture>
                    <svg
                        class="animation-berries"
                        :class="{ 'is-animated': secondStep }"
                        width="300"
                        height="270"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle
                            cx="64.5"
                            cy="101.5"
                            r="4.5"
                            fill="#FF2B2B"
                            stroke="#454C48"
                            stroke-width="2"
                        />
                        <circle
                            cx="78.5"
                            cy="103.5"
                            r="4.5"
                            fill="#FF2B2B"
                            stroke="#454C48"
                            stroke-width="2"
                        />
                        <circle
                            cx="143.5"
                            cy="102.5"
                            r="4.5"
                            fill="#FF2B2B"
                            stroke="#454C48"
                            stroke-width="2"
                        />
                        <circle
                            cx="114.5"
                            cy="85.5"
                            r="4.5"
                            fill="#FF2B2B"
                            stroke="#454C48"
                            stroke-width="2"
                        />
                        <circle
                            cx="101.5"
                            cy="79.5"
                            r="4.5"
                            fill="#FF2B2B"
                            stroke="#454C48"
                            stroke-width="2"
                        />
                        <circle
                            cx="107.5"
                            cy="99.5"
                            r="4.5"
                            fill="#FF2B2B"
                            stroke="#454C48"
                            stroke-width="2"
                        />
                    </svg>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    .home-work {
        padding: 24px;
        border-radius: var(--border-md);
        box-shadow: var(--primary-shadow);
        @include bp($bp-desktop-sm) {
            position: relative;
            padding: 48px 64px;
            border-radius: var(--border-xl);
            .width-435 {
                max-width: 435px;
                width: 100%;
                margin-right: 40px;
            }
            .width-315 {
                max-width: 315px;
                width: 100%;
                margin-right: 40px;
            }
        }
    }

    .home-work__line {
        display: none;
        @include bp($bp-desktop-sm) {
            display: block;
            position: absolute;
            top: 35%;
            left: 30%;
            pointer-events: none;
        }
    }

    .home-work__title {
        margin-bottom: 12px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 46px;
        }
    }

    .home-work__row {
        @include bp($bp-desktop-sm) {
            display: flex;
            &:nth-of-type(2) {
                align-items: center;
                margin-bottom: 30px;
                .home-work__text {
                    order: 1;
                }
            }
        }
    }

    .home-work__text {
        margin-bottom: 12px;
        font-size: 14px;
        line-height: 30px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 0;
            font-size: 16px;
        }
    }

    .home-work__caption {
        margin-bottom: 12px;
        font-family: var(--secondary-font);
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        text-align: center;
        @include bp($bp-desktop-sm) {
            font-size: 18px;
            line-height: 30px;
            text-align: left;
        }
    }

    .home-work__image-wrapper {
        img {
            margin: 0 auto;
        }
        @include bp($bp-desktop-sm) {
            flex-shrink: 0;
            img {
                margin: 0;
            }
        }
    }

    .home-work__image {
        display: none;
        @include bp($bp-desktop-sm) {
            position: relative;
            display: block;
            width: 300px;
            height: 270px;
            img,
            svg {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }
    }

    /* Animation */
    $duration: 2s;
    $delay: $duration;
    .animation-line {
        stroke-dasharray: 1100;
        stroke-dashoffset: 1100;
        &.is-animated-1 {
            animation: animation-line-1 $duration linear forwards;
        }
        &.is-animated-2 {
            animation: animation-line-2 $duration linear forwards;
        }
    }

    .animation-circle {
        opacity: 0;
        transition: opacity 0.3s ease-in;
        &.is-animated {
            opacity: 1;
        }
    }
    .animation-circle--2 {
        transition-delay: 2s;
    }
    .animation-circle--3 {
        transition-delay: 2s;
    }

    .animation-water {
        &.is-animated {
            animation: animation-water $duration linear forwards;
        }
    }

    .animation-light {
        opacity: 0;
        &.is-animated {
            animation: animation-light 1.2s linear $delay forwards;
        }
    }

    .animation-berries {
        circle {
            opacity: 1;
            transform: scale(0);
            transform-box: fill-box;
            transform-origin: center;
            transition: transform 0.3s ease-in $delay, opacity 0.3s ease-in $delay;
        }
        &.is-animated {
            circle {
                opacity: 1;
                transform: scale(1);
            }
        }
    }

    @keyframes animation-line-1 {
        0% {
            stroke-dashoffset: 1100;
        }
        100% {
            stroke-dashoffset: 550;
        }
    }

    @keyframes animation-line-2 {
        0% {
            stroke-dashoffset: 550;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }

    @keyframes animation-water {
        0%,
        66% {
            transform: translateY(-5px);
        }
        33%,
        100% {
            transform: translateY(0);
        }
    }

    @keyframes animation-light {
        0% {
            opacity: 0;
        }
        7% {
            opacity: 1;
        }
        13% {
            opacity: 0.2;
        }
        21% {
            opacity: 0.7;
        }
        33% {
            opacity: 0.3;
        }
        41% {
            opacity: 0.9;
        }
        60% {
            opacity: 0.1;
        }
        73% {
            opacity: 0.6;
        }
        83% {
            opacity: 0.2;
        }
        88% {
            opacity: 1;
        }
        91% {
            opacity: 0.5;
        }
        100% {
            opacity: 1;
        }
    }
</style>
